// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Resource } from "./resource.js";
/** Immutable QuerySet object */
export class QuerySet extends Resource {
    static defaultProps = {
        ...Resource.defaultProps,
        type: undefined,
        count: undefined
    };
    get [Symbol.toStringTag]() {
        return 'QuerySet';
    }
    constructor(device, props) {
        super(device, props, QuerySet.defaultProps);
    }
}
//# sourceMappingURL=query-set.js.map